"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { cn } from "~/utils/fontsConfig";

export const ScrollableContainer = ({
    children,
    className,
    wrapperClassName,
    ref,
    topShadowColor = "from-black/80 to-transparent border-t border-v3-N-450",
    bottomShadowColor = "from-v4-card-gray/80 to-v4-card-gray/0",
}: {
    children: React.ReactNode;
    className?: string;
    wrapperClassName?: string;
    ref?: React.RefObject<HTMLDivElement | null>;
    topShadowColor?: string;
    bottomShadowColor?: string;
}) => {
    // create a ref for the scrolling container
    const localRef = useRef<HTMLDivElement>(null);
    const scrollContainerRef = ref || localRef;
    const { scrollY } = useScroll({ container: scrollContainerRef });
    // transform scrollY to opacity
    const topGradientOpacity = useTransform(scrollY, [0, 20], [0, 1]);

    return (
        <div className={cn("relative", wrapperClassName)}>
            <div
                ref={scrollContainerRef}
                className={cn("relative overflow-y-auto pt-4", className)}
            >
                {children}
            </div>
            {/* top and bottom gradient overlay imitating shadow */}
            <motion.div
                className={cn(
                    "pointer-events-none absolute inset-x-0 top-0 h-8 w-full",
                    "bg-gradient-to-b",
                    topShadowColor,
                )}
                style={{ opacity: topGradientOpacity }}
            />
            <div
                className={cn(
                    "pointer-events-none absolute inset-x-0 bottom-0 h-8 w-full",
                    "bg-gradient-to-t mix-blend-darken",
                    bottomShadowColor,
                )}
            />
        </div>
    );
};
